import { Dialog, IconButton, styled } from '@mui/material'

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  zIndex: 999997,
  backgroundImage: 'none',
  '& .MuiDialog-paper': {
    backgroundImage: 'none',
    border: '1px solid rgba(255, 255, 255, 0.3)'
  }
}))
